<template>
  <div class="container-fluid">
    <nuvei-card-form
      :loading="loading"
      :nuveiCardData="nuveiCard"
      :formErrors="formErrors"
      @nuveiCardSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultNuveiCard from "../defaultNuveiCard";
import NuveiCardForm from "../partials/NuveiCardForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    NuveiCardForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      nuveiCard: cloneDeep(defaultNuveiCard),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(nuveiCard) {
      this.loading = true;

      const nuveiCardData = cloneDeep(nuveiCard);
      delete nuveiCardData.id;

      try {
        await this.$store.dispatch("nuveiCards/add", nuveiCardData);
        this.$notify({
          type: "success",
          message: this.$t("NUVEI_CARDS.NUVEI_CARD_ADDED"),
        });
        const nuveiCard = await this.$store.getters["nuveiCards/nuveiCard"];
        this.$emit("onViewNuveiCard", nuveiCard, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
